var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FileText"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 21H5.24996C5.05106 21 4.8603 20.921 4.71965 20.7803C4.57901 20.6397 4.5 20.4489 4.5 20.25V3.75C4.5 3.55109 4.57901 3.36033 4.71965 3.21968C4.8603 3.07903 5.05106 3 5.24996 3H14.2503L19.5 8.25V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21V21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3V8.25H19.5007",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3V8.25H19.5007",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 12.75H15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 15.75H15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4fdc21b3e3edb0668bc4e0da3c1489c4.svg";
export { ForwardRef as ReactComponent };